import { questionsLoader } from "./QuestionsLoader";

export class FilesApi {
    public static uploadFiles(data: FormData, onUploadProgress: (progressEvent: ProgressEvent) => void) {
        return questionsLoader.post({
            baseURL: process.env.REACT_APP_QUESTIONS_URL,
            url: "/files",
            headers: { "Content-type": "multipart/form-data" },
            data,
            onUploadProgress,
        });
    }
}
